import Script from "next/script";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Webchat = props => {
  var {
    queue,
    deploymentKey,
    orgGuid
  } = props;

  function init() {
    // @ts-ignore
    if (window && window.CXBus) {
      // @ts-ignore
      window._genesys = {
        widgets: {
          main: {
            downloadGoogleFont: false,
            theme: "light"
          },
          webchat: {
            emojis: true,
            uploadsEnabled: true,
            chatButton: {// enabled: true, // (boolean) Enable/disable chat button on screen.
              // template: "<div>Live Chat</div>", // (string) Custom HTML string template for chat button.
              // effect: "fade", // (string) Type of animation effect when revealing chat button. 'slide' or 'fade'.
              // openDelay: 1000, // (number) Number of milliseconds before displaying chat button on screen.
              // effectDuration: 300, // (number) Length of animation effect in milliseconds.
              // hideDuringInvite: true, // (boolean) When auto-invite feature is activated, hide the chat button. When invite is dismissed, reveal the chat button again.
            },
            transport: {
              type: "purecloud-v2-sockets",
              dataURL: "https://api.mypurecloud.com.au",
              // replace with API URL matching your region
              deploymentKey,
              // replace with your Deployment ID
              orgGuid,
              // replace with your Organization ID
              interactionData: {
                routing: {
                  targetType: "QUEUE",
                  targetAddress: queue,
                  priority: 5
                }
              }
            } // form: {
            //   wrapper: "<table></table>",
            //   inputs: [
            //     {
            //       id: "cx_webchat_form_firstname",
            //       name: "firstname",
            //       maxlength: "100",
            //       placeholder: "@i18n:webchat.ChatFormPlaceholderFirstName",
            //       label: "@i18n:webchat.ChatFormFirstName",
            //     },
            //     {
            //       id: "cx_webchat_form_lastname",
            //       name: "lastname",
            //       maxlength: "100",
            //       placeholder: "@i18n:webchat.ChatFormPlaceholderLastName",
            //       label: "@i18n:webchat.ChatFormLastName",
            //     },
            //     {
            //       id: "cx_webchat_form_email",
            //       name: "email",
            //       maxlength: "100",
            //       placeholder: "@i18n:webchat.ChatFormPlaceholderEmail",
            //       label: "@i18n:webchat.ChatFormEmail",
            //     },
            //     {
            //       id: "cx_webchat_form_subject",
            //       name: "subject",
            //       maxlength: "100",
            //       placeholder: "@i18n:webchat.ChatFormPlaceholderSubject",
            //       label: "@i18n:webchat.ChatFormSubject",
            //     },
            //   ],
            // },

          },
          callback: {
            // dataURL: "https://api.mypurecloud.com.au",
            // userData: {},
            // dataURL: "https://api.mypurecloud.com.au/engagement/v3/callbacks",
            countryCodes: false,
            immediateCallback: true,
            scheduledCallback: true // ewt: {
            //   display: true,
            //   queue: "Training Queue",
            //   threshold: 2000,
            //   immediateCallback: {
            //     thresholdMin: 1000,
            //     thresholdMax: 3000,
            //   },
            // },

          },
          calendar: {
            showAvailability: true,
            numberOfDays: 5,
            hideUnavailableTimeSlots: true,
            calendarHours: {
              interval: 15,
              allDay: {
                openTime: "09:00",
                closeTime: "16:59"
              }
            }
          },
          channelselector: {
            // ewtRefreshInterval: 10,
            channels: [{
              enable: true,
              clickCommand: "CallUs.open",
              displayName: "Call Us",
              i18n: "CallusTitle",
              icon: "call-outgoing" // html: '<img src="http://placehold.it/100x100">',
              // ewt: {
              //   display: true,
              //   queue: "Training Queue",
              // availabilityThresholdMin: 300,
              // availabilityThresholdMax: 480,
              // hideChannelWhenThresholdMax: false,
              // },

            }, {
              enable: true,
              clickCommand: "WebChat.open",
              displayName: "Web Chat",
              i18n: "ChatTitle",
              icon: "chat" // html: "",
              // ewt: {
              //   display: true,
              //   queue: "Training Queue",
              // availabilityThresholdMin: 300,
              // availabilityThresholdMax: 480,
              // hideChannelWhenThresholdMax: false,
              // },

            }, {
              enable: true,
              clickCommand: "Callback.open",
              displayName: "Receive a Call",
              i18n: "CallbackTitle",
              icon: "call-incoming" // html: "",
              // ewt: {
              //   display: true,
              //   queue: "Training Queue",
              // availabilityThresholdMin: 300,
              // availabilityThresholdMax: 480,
              // hideChannelWhenThresholdMax: false,
              // },

            }]
          },
          callus: {
            contacts: [{
              displayName: "Call Us",
              i18n: "Number001",
              number: "13 11 20"
            }],
            hours: ["9am - 5pm Mon - Fri"]
          },
          sidebar: {
            showOnStartup: true,
            position: "right",
            expandOnHover: false,
            channels: [{
              name: "ChannelSelector",
              clickCommand: "ChannelSelector.open",
              clickOptions: {},
              //use your own static string or i18n query string for the below two display properties
              displayName: "Live Assist",
              displayTitle: "Get live help",
              icon: "agent"
            } // {
            //   name: "WebChat",
            // },
            // {
            //   name: "Callback",
            // },
            // {
            //   name: "CallUs",
            // },
            ]
          }
        }
      }; // @ts-ignore

      window.CXBus.configure({
        debug: true,
        pluginsPath: "https://apps.mypurecloud.com.au/widgets/9.0/plugins/"
      }); // @ts-ignore
      // window.CXBus.loadFile(
      //   "https://ccq-cdn.vercel.app/static/widget.config.js"
      // ).done(function () {
      // @ts-ignore

      window.CXBus.loadPlugin("widgets-core"); // @ts-ignore

      window.customPlugin = window.CXBus.registerPlugin("Custom"); // @ts-ignore

      window.customPlugin.command("SideBar.open"); // });
    }
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      children: "\n      .cx-widget {\n        font-family: inherit;\n        border-radius: var(--container-border-radius) !important;\n      }\n\n      .cx-branding, .cx-powered-by {\n        display: none !important;\n      }\n\n      .cx-sidebar-button {\n        background: rgb(var(--colors-bg-primary)) !important;\n      }\n\n      .cx-sidebar .cx-svg-icon-tone1 {\n        fill: rgb(var(--colors-text-primary)) !important;\n      }\n\n      .ow-modal .cx-svg-icon-tone1 {\n        fill: rgb(var(--colors-bg-primary)) !important;\n      }\n\n      .cx-widget.cx-theme-light, .cx-widget .cx-container {\n        color: rgb(var(--colors-text-foreground)) !important;\n      }\n\n      .cx-title, .cx-name {\n        color: rgb(var(--colors-text-foreground)) !important;\n        font-weight: 900 !important;\n      }\n\n      .cx-widget.cx-theme-light label {\n        color: rgb(var(--colors-text-foreground)) !important;\n        font-weight: 400 !important;\n        font-size: 0.85rem !important;\n      }\n\n      .cx-titlebar > .cx-icon {\n        display: none !important;\n      }\n\n      .cx-control-label {\n        color: white !important;\n      }\n\n      .cx-btn {\n        font-weight: var(--button-font-weight) !important;\n        font-size: 1rem !important;\n        color: rgb(var(--colors-text-primary)) !important;\n        background: rgb(var(--colors-bg-primary)) !important;\n        padding-left: var(--button-px-md) !important;\n        padding-right: var(--button-px-md) !important;\n        padding-top: var(--button-py-md) !important;\n        padding-bottom: var(--button-py-md) !important;\n        border-radius: var(--button-border-radius) !important;\n        border: 0 !important;\n      }\n      "
    }), /*#__PURE__*/_jsx(Script, {
      "data-chromatic": "ignore",
      src: "https://apps.mypurecloud.com.au/widgets/9.0/cxbus.min.js",
      strategy: "lazyOnload",
      onLoad: init
    })]
  });
};
//# sourceMappingURL=webchat.js.map